module.exports = __webpack_public_path__ + "static/media/crowd-mgmt.95a44293.png";